import Sheet from '../Sheet';
import { BTN_PRIMARY } from '../buttonStyles';
import { whenLine } from '../../utils/liveCalendar';

/**
 * The coach's confirmation on send (decision 160, booking.md 5a): "Sent to Ana", the times one per row, the
 * line by count, "Ana can pick one. Until then the lesson stays Tue, Nov 3 at 2:00 PM.", and Done: no keep, since
 * not answering keeps the time (165 as amended). It shows the moment the times are sent (157); the call runs behind it.
 */
export function SentTimesSheet({ playerFirst, times, fromStartAt, tz, onDone }: {
  playerFirst: string; times: string[]; fromStartAt: string; tz: string; onDone: () => void;
}) {
  return (
    <Sheet title={`Sent to ${playerFirst}`} onClose={onDone} hideDismiss>
      <div className="pb-2 pt-2" data-sent-times>
        <ul className="overflow-hidden rounded-[26px] bg-white">
          {times.map((s, i) => (
            <li key={s} className={`px-4 ${i ? 'border-t border-[#e6e6e6]' : ''}`}>
              <span className="flex min-h-[52px] items-center text-[17px] leading-[22px] tracking-[-0.43px] tabular-nums text-db-text-1">{whenLine(s, tz)}</span>
            </li>
          ))}
        </ul>
        <p className="mt-2 px-4 text-[13px] leading-[18px] text-db-text-2">
          {playerFirst} can {times.length === 1 ? 'confirm it' : 'pick one'}. Until then the lesson stays {whenLine(fromStartAt, tz)}.
        </p>
        <button type="button" onClick={onDone} className={`${BTN_PRIMARY} mt-6 w-full`}>Done</button>
      </div>
    </Sheet>
  );
}
